var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcComments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87 15.5L8 15L10 11.5H13C13.2652 11.5 13.5196 11.3946 13.7071 11.2071C13.8946 11.0196 14 10.7652 14 10.5V4.5C14 4.23478 13.8946 3.98043 13.7071 3.79289C13.5196 3.60536 13.2652 3.5 13 3.5H3C2.73478 3.5 2.48043 3.60536 2.29289 3.79289C2.10536 3.98043 2 4.23478 2 4.5V10.5C2 10.7652 2.10536 11.0196 2.29289 11.2071C2.48043 11.3946 2.73478 11.5 3 11.5H7.5V12.5H3C2.46957 12.5 1.96086 12.2893 1.58579 11.9142C1.21071 11.5391 1 11.0304 1 10.5V4.5C1 3.96957 1.21071 3.46086 1.58579 3.08579C1.96086 2.71071 2.46957 2.5 3 2.5H13C13.5304 2.5 14.0391 2.71071 14.4142 3.08579C14.7893 3.46086 15 3.96957 15 4.5V10.5C15 11.0304 14.7893 11.5391 14.4142 11.9142C14.0391 12.2893 13.5304 12.5 13 12.5H10.58L8.87 15.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5H4V6.5H12V5.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.5H4V9.5H9V8.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComments);
export default __webpack_public_path__ + "static/media/ic-comments.1f3dfe1b22d1e389480aa63329eb0d53.svg";
export { ForwardRef as ReactComponent };